/* identity only, not a button: there is nothing to open here and a dead
 * control reads as broken on touch. */
export function SidebarUserRow({
  name,
  email
}: {
  name: string | null | undefined
  email: string | null | undefined
}) {
  return (
    <div className='flex h-12 w-full items-center gap-2 rounded-md p-2 text-left group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-0!'>
      <div className='flex size-8 shrink-0 items-center justify-center rounded-full bg-accent text-xs font-semibold text-white'>
        {initials(name)}
      </div>
      <div className='grid flex-1 text-left text-sm leading-tight group-data-[collapsible=icon]:hidden'>
        <span className='truncate font-semibold'>{name ?? '—'}</span>
        <span className='truncate text-xs text-sidebar-foreground/60'>
          {email}
        </span>
      </div>
    </div>
  )
}

function initials(name: string | null | undefined): string {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/)
  const first = parts[0]?.[0] ?? ''
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : ''
  return (first + last).toUpperCase() || '?'
}
